<template>
    <!-- <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" data-testid="directions-74" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Search Filter</ion-title>
        <ion-buttons slot="end">
            <ion-button data-testid="directions-75" @click="reset">
                <span>Reset</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar> -->

    <div class="main_wrapper ion-padding">
        <el-button class="reset-button" @click="reset">Reset</el-button>
        <!-- <div class="search-bar">
            <img src="@/assets/img/job-seeker/jam_search.svg" class="search-icon" height="20" alt="Search" />
            <el-input data-testid="directions-76" v-model="selectedValues.text" class="job-board__search"
                placeholder="Search" clearable @clear="clearText">
            </el-input>
            <button class="filter-button">
                <img src="@/assets/img/job-seeker/setting-active.svg" />
            </button>
        </div> -->
        <div v-if="loading">
            <JobListingFilterSkeleton :skeletonCount="1" />
        </div>
        <div v-else>
            <div v-if="isFilterOptionsVisible" class="filter-options">
                <div class="filter-type">
                    <h3 class="filter-title">Filter by Job Type</h3>
                    <div class="filter-item">
                        <div class="filter-select" v-for="(type, index) in jobTypes" :key="index">
                            <input data-testid="directions-77" type="radio" name="type" :id="'jobType-' + index"
                                v-model="selectedValues.jobType" :value="type.title">
                            <label :for="'jobType-' + index">{{ type.title }}</label>
                        </div>
                    </div>
                </div>
                <div class="filter-type">
                    <h3 class="filter-title">Filter by Job Location</h3>
                    <!-- <div class="filter-item" v-if="isAustralia">
                        <div class="filter-select" v-for="(location, index) in jobLocations" :key="index">
                            <input data-testid="directions-78" type="radio" name="location" :id="'location-' + index"
                                v-model="selectedValues.jobLocation" :value="location.alphaCode">
                            <label :for="'location-' + index">{{ location.name }}</label>
                        </div>
                    </div> -->
                    <div class="filter-item el-input">
                        <vue-google-suburb-autocomplete 
                            data-testid="directions-102" 
                            id="map" 
                            classname="el-input__inner"
                            v-model="selectedValues.jobLocation"
                            placeholder="Job Location" 
                            v-on:placechanged="updateAddressData"
                            @keyup="setAddress"
                            :initial-location="selectedValues.jobLocation"
                            :country="countryArray"
                            :key="addressComponent"
                        />
                    </div>
                </div>
                <!-- <el-radio-group v-model="rateType" size="large">
                    <h3 class="filter-title">Filter by </h3>
                    <el-radio size="large" label="hourly">Hourly Rate</el-radio>
                    <el-radio size="large" label="annual">Annual Salary</el-radio>
                </el-radio-group>
                <RangeSlider :min="sliderConfig.min" :max="sliderConfig.max" :initialValue="sliderConfig.initialValue"
                    @change="handleSliderChange" /> -->
                <div class="filter-type">
                    <h3 class="filter-title">Tagged Skills</h3>
                    <div class="filter-item">
                        <div class="filter-select" v-for="(skill, index) in taggedSkills" :key="index">
                            <input data-testid="directions-79" type="checkbox" name="tagged-skills"
                                :id="'skill-' + index" v-model="selectedValues.taggedSkills" :value="skill.name">
                            <label :for="'skill-' + index">{{ skill.name }} </label>
                        </div>
                    </div>
                </div>
                <div class="filter-type" v-if="isUS">
                    <h3 class="filter-title">Filter by Federal Pharmacist Support
                    </h3>
                    <div class="filter-item">
                        <div class="filter-select" v-for="(type, index) in federalPharmacistSupport" :key="index">
                            <input data-testid="directions-77" type="radio" name="type" :id="'federalPharmacistSupport-' + index"
                                v-model="selectedValues.federalPharmacistSupport" :value="type">
                            <label :for="'federalPharmacistSupport-' + index">{{ type }}</label>
                        </div>
                    </div>
                </div>
            </div>

            
            <el-form-item class="button_submit mb0">
                <el-button class="submit" type="blue" data-testid="directions-80" @click="goSearch">
                    Apply
                </el-button>
            </el-form-item>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, computed, defineEmits } from 'vue';
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import JobListingFilterSkeleton from "@/components/JobListingSkeleton/JobListingFilterSkeleton.vue";
// import RangeSlider from "@/components/RangeSlider/RangeSlider.vue";
import { isAustraliaRegion, isUSRegion } from '@/helpers/region/regionHelper.js';
import { VueGoogleSuburbAutocomplete } from "@/components/components";

// const props = defineProps({
//   modalCreateVisible: {
//     type: Boolean,
//     required: true,
//   },
// });
const isAustralia = isAustraliaRegion();
const isUS = isUSRegion();

const $store = useStore();
const $router = useRouter();
const isFilterOptionsVisible = ref(true);
const currentRouteName = ref(null);
const selectedValues = ref({
    text: '',
    jobType: '',
    jobLocation: '',
    taggedSkills: [],
    federalPharmacistSupport: '',

    // rate: {
    //     type: '',
    //     value: 0
    // }
});
const addressComponent = ref(0);
const loading = ref(false);
const jobTypes = ref([]);
const taggedSkills = ref([]);
const jobLocations = ref([]);
const federalPharmacistSupport= ref([]);
// const sliderValue = ref(null);
// const rateType = ref("");
const emit = defineEmits(['update:modalCreateVisible']);
// Function to reset filters
const reset = () => {
    localStorage.removeItem('jobSeekerBrowseFilterObject');
    selectedValues.value = {
        text: '',
        jobType: '',
        jobLocation: '',
        taggedSkills: [],
        federalPharmacistSupport: '',
        // rate: {
        //     type: '',
        //     value: 0
        // }
    };
    // rateType.value = "";
    // sliderValue.value = 0;
    addressComponent.value = addressComponent.value + 1;
}

const countryArray = computed(() => {
    const region = process.env.VUE_APP_REGION;
    if (region === 'US') return ['us'];
    if (region === 'AU') return ['au'];
    return []; // Default or empty if region is not recognized
});

// function handleSliderChange(event) {
//     if (rateType.value === "") {
//         rateType.value = "hourly";
//     }
//     const numericValue = parseFloat(event.target.value);
//     sliderValue.value = event.target.value; // Updating parent value with the value emitted from child
//     selectedValues.value.rate.value = numericValue;
// }


// Watch for changes in rateType
// watch(rateType, (newValue) => {
//     selectedValues.value.rate.type = newValue; // Update selectedValues object
//     if(newValue === 'hourly' && selectedValues.value.rate.value > 200 || newValue === 'annual' && selectedValues.value.rate.value < 200) {
//         sliderValue.value = 200;
//         selectedValues.value.rate.value = 200;
//     }
// });
// Computed property to determine slider configuration based on rateType
// const sliderConfig = computed(() => {
//     if (rateType.value === 'hourly') {
//         return {
//             min: 0,
//             max: 200,
//             initialValue: sliderValue.value ? sliderValue.value : 0
//         };
//     } else if (rateType.value === 'annual') {
//         return {
//             min: 200,
//             max: 200000,
//             initialValue: sliderValue.value ? sliderValue.value : 20000
//         };
//     } else {
//         // Default values in case rateType is not set
//         return {
//             min: 0,
//             max: 200,
//             initialValue: sliderValue.value ? sliderValue.value : 0
//         };
//     }
// });


// Function to navigate back
// const goBack = () => {
//     currentRouteName.value = $router.currentRoute.value.name;
//     console.log("🚀 ~ setup ~ currentRouteName.value:", currentRouteName.value)
//     $store.dispatch('PREVIOUS_ROUTE_NAME', currentRouteName.value);

//     $router.push({
//         name: "job_seeker_index",
//     });
// };

// Function to perform search
const goSearch = () => {
    // Save selected values to local storage
    localStorage.setItem('jobSeekerBrowseFilterObject', JSON.stringify(selectedValues.value));

    // Perform search action
    currentRouteName.value = $router.currentRoute.value.name;
    $store.dispatch('PREVIOUS_ROUTE_NAME', currentRouteName.value);
    // $router.push({
    //     name: "job_seeker_index",
    // });
    emit('update:modalCreateVisible', false);
    emit("job-filter");
};

// const clearText = () => {
//     console.log('clear text')
//     selectedValues.value.text = '';
//     // Update local storage to remove only the 'text' property from 'jobSeekerBrowseFilterObject'
//     const storedValues = JSON.parse(localStorage.getItem('jobSeekerBrowseFilterObject'));
//     if (storedValues) {
//         delete storedValues.text;
//         localStorage.setItem('jobSeekerBrowseFilterObject', JSON.stringify(storedValues));
//     }
// };

const jobListingAttributesForFilter = () => {
    loading.value = true;
    (async () => {
        const existingCvResponse = await $store.dispatch("GET_JOB_POSTER_LISTINGS");
        loading.value = false;
        jobTypes.value = existingCvResponse.data.type;
        if(isAustralia) {
            jobLocations.value = existingCvResponse.data.location;
        }
        taggedSkills.value = existingCvResponse.data.popularSkills;

        if(isUS.value){
            federalPharmacistSupport.value = existingCvResponse.data.federalPharmacistSupport;
        }
    })();
}
const updateAddressData = (addressData) => {
    selectedValues.jobLocation = '';
    selectedValues.value.jobLocation = addressData.formatted_address;
};

const setAddress = () => {
    selectedValues.value.jobLocation = '';
};

// Restore selected values from local storage on component mount
onMounted(() => {
    const storedValues = localStorage.getItem('jobSeekerBrowseFilterObject');
    if (storedValues) {
        const parsedValues = JSON.parse(storedValues);
        selectedValues.value = parsedValues;
        addressComponent.value = addressComponent.value + 1;
        // rateType.value = parsedValues.rate.type;

        // Set the sliderValue to the stored value
        // sliderValue.value = parseFloat(parsedValues.rate.value);
    }

    jobListingAttributesForFilter()
});

</script>
